import qs from 'query-string';


const APP_PROPERTIES_STORE = `CINEMO_APP_PROPERTIES`;

const appProperties = {
  ltd: false,
};

export const setAppProperty = (property, value) => {
  appProperties[property] = value;

  saveAppProperties();
};

export const saveAppProperties = () => {
  localStorage.setItem(APP_PROPERTIES_STORE, JSON.stringify(appProperties));
};

export const initAppProperties = () => {
  let savedProperties = {};
  try {
    const serializedProperties = localStorage.getItem(APP_PROPERTIES_STORE);
    if (serializedProperties) {
      savedProperties = JSON.parse(serializedProperties);
    }
  } catch (e) {
    console.error('Error trying to load the app properties:', e);
    localStorage.removeItem(APP_PROPERTIES_STORE);
  }

  const parsed = qs.parse(window.location.search);

  appProperties.ltd = parsed.ltd && parsed.ltd !== '0' && parsed.ltd.toLowerCase() !== 'false';

  saveAppProperties();

  return appProperties;
};

export default appProperties;
